import React from 'react';
import {createRoot} from 'react-dom/client';
import {StorePageComponent} from './storepage/storepage';
import * as Sentry from '@sentry/react';

declare var __domain_name: string;
declare var __is_production: string;

Sentry.init({
    dsn: 'https://b2db459d7dc0ea78a26c57e6e1ee5647@o367868.ingest.us.sentry.io/4508019535380480',
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    tracesSampleRate: __is_production === '1' ? 0.05 : 1,
    tracePropagationTargets: ['localhost', __domain_name],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    ignoreErrors: ['Non-Error exception captured', 'Non-Error promise rejection captured', 'InitializationError'],
    environment: __is_production === '1' ? 'production' : 'development',
});

const myErrorHandler = (error: Error, componentStack: string) => {
    console.log('ERROR', error.message);
};

document.addEventListener('DOMContentLoaded', function () {
    const container: HTMLElement = document.getElementById('store-es') as HTMLElement;
    if (container) {
        const root = createRoot(container);
        root.render(<StorePageComponent />);
    }
});
